module.exports = __webpack_public_path__ + "img/icon-games-yellow.79881ad3.svg";